var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home-container" }, [
    _c("div", { staticClass: "header-container" }, [
      _c("div", { staticClass: "flex-center" }, [
        _c("img", {
          staticClass: "header-logo-img",
          attrs: { src: require("@/assets/images/logo.png") },
          on: {
            click: function ($event) {
              return _vm.$router.push({ path: "/" })
            },
          },
        }),
        _c(
          "span",
          {
            staticStyle: {
              "font-size": "14px",
              "font-weight": "bold",
              color: "black",
            },
          },
          [_vm._v("大头问卷系统")]
        ),
      ]),
      _c(
        "div",
        { staticClass: "right-header" },
        [
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container",
              attrs: { trigger: "click", size: "medium" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "avatar-wrapper",
                  staticStyle: { cursor: "pointer" },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-user",
                    staticStyle: { margin: "0 5px" },
                  }),
                  _c("span", { staticClass: "user_name" }, [
                    _vm._v(_vm._s(_vm.getUserInfo.name)),
                  ]),
                  _c("i", {
                    staticClass: "el-icon-caret-bottom",
                    staticStyle: { top: "20px" },
                  }),
                ]
              ),
              _c(
                "el-dropdown-menu",
                {
                  staticClass: "user-dropdown",
                  attrs: { slot: "dropdown" },
                  slot: "dropdown",
                },
                [
                  _c("el-dropdown-item", [
                    _c("span", [_vm._v(_vm._s(_vm.getUserInfo.name))]),
                  ]),
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logoutHandle.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "person-menu-item" },
                        [
                          _c("font-icon", { staticClass: "fas fa-sign-out" }),
                          _vm._v(" 退出登录 "),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "content-container" },
      [
        _c("menu-tree", { attrs: { navTree: _vm.getNavTree } }),
        _c("div", { staticClass: "view-container" }, [_c("router-view")], 1),
        _vm.showHello && _vm.$route.path === "/home"
          ? _c(
              "div",
              {
                staticClass: "hello-container flex-center",
                on: { click: _vm.handleClick },
              },
              [
                _c("el-image", {
                  staticClass: "hello-container-img",
                  style: { height: _vm.defaultH + "px" },
                  attrs: { src: "https://cdn.jmj1995.com/survey/hello.png" },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }